import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetActiveMenuToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Box, Grid } from "@mui/material";
// import { Check, Delete, Edit } from "@mui/icons-material";
import TableList from "./CustomTool/TableList";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtCheckBox from "./CustomTool/CtCheckBox";
import { apiURL } from "./API";

class SalesInvoiceSelection extends Component {
  state = {
    CheckedInvoiceList: [],
    columns: [
      {
        id: "SelectInvoice",
        label: "Select Invoice",
        type: "Chk",
        CtrlProps: { value: false, width: 50 },
      },
      { id: "BillSelection", label: "Selection" },
    ],
    rows: [
      { SelectInvoice: true, BillSelection: "Original" },
      { SelectInvoice: false, BillSelection: "Duplicate" },
      { SelectInvoice: false, BillSelection: "Triplicate" },
    ],
    formData: {
      cmbPaper: "Letterhead",
      chkPrintSignatureAndStamp: this.props.IntSignature_StampPrint,
    },
    PaperList: [{ name: "Letterhead" }, { name: "Blank Page" }],
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,

    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    // document.title = "RiTe Account : Sales Invoice Selection";
    this.props.setActiveMenu("SalesInvoiceSelection");
    this.setState({
      formData: {
        ...this.state.formData,
        cmbPaper: this.props.SalesInvoiceDefaultPrint
          ? this.props.SalesInvoiceDefaultPrint
          : "Letterhead",
        chkPrintSignatureAndStamp: this.props.IntSignature_StampPrint
          ? this.props.IntSignature_StampPrint
          : 0,
      },
    });
  }
  //#endregion Component

  //#region Handles
  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick = (values) => {
    const bint_acid = values[0].value,
      txtCompanyName = values[1].value,
      txtGSTNo = values[2].value,
      actionName = values[0].actionName;
    if (actionName === "SelectCompany") {
      localStorage.setItem("acid", bint_acid);
      localStorage.setItem("CompanyName", txtCompanyName);
      localStorage.setItem("GSTNo", txtGSTNo);
    }
  };

  handleOnChkChange = (e) => {
    // console.log("e.target.checked", e.target.checked);
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
      },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  //#endregion Handles

  //#region Function
  validateSelectionData = () => {
    let result = false;
    if (this.state.formData.cmbPaper.length <= 0) {
      this.props.toastErrorMsg("Select Paper");
    } else if (this.validateInvoiceSelection() == false) {
      this.props.toastErrorMsg("Select atleast one Selection to openn Invoice");
    } else {
      result = true;
    }
    return result;
  };

  SelectAll = () => {
    let rows = this.state.rows.map((row) => {
      return { ...row, SelectInvoice: true };
    });
    this.setState({ rows });
  };

  ClearAll = () => {
    let rows = this.state.rows.map((row) => {
      return { ...row, SelectInvoice: false };
    });
    this.setState({ rows });
  };

  getSelectedInvoice = () => {
    let rows = [];
    this.state.rows.map((row) => {
      if (row.SelectInvoice == true) {
        rows.push(row.BillSelection);
      }
    });
    return rows;
  };

  setSalesInvoiceSelection = (CheckedInvoiceList) => {
    // console.log("CheckedInvoiceList", CheckedInvoiceList);
    this.setState({
      CheckedInvoiceList,
    });
  };

  validateInvoiceSelection = () => {
    let result = false;
    this.state.rows.map((row) => {
      if (row.SelectInvoice == true) {
        result = true;
      }
    });
    return result;
  };

  openInvoicePrint = () => {
    if (this.validateSelectionData()) {
      let selectedInvoice = this.getSelectedInvoice();
      // this.setSalesInvoiceSelection(selectedInvoice)
      this.openInvoice(
        this.props.bint_acid,
        this.props.bint_acyear,
        this.props.vac_billno,
        selectedInvoice,
        this.props.array_billno ? this.props.array_billno : [],
        this.props.bint_frombillno ? this.props.bint_frombillno : 0,
        this.props.bint_tobillno ? this.props.bint_tobillno : 0,
        this.props.vac_customer ? this.props.vac_customer : "",
        this.props.dat_fromdate ? this.props.dat_fromdate : "",
        this.props.dat_todate ? this.props.dat_todate : ""
      );
    }
  };

  // openInvoice = (bint_acid, bint_acyear, vac_billno, CheckedInvoiceList) => {
  //     this.props.notifyProcessing();
  //     let reqData = [
  //         { name: 'Op', value: 'SalesInvoicePrint' },
  //         { name: 'bint_acid', value: bint_acid },
  //         { name: 'bint_acyear', value: bint_acyear },
  //         { name: 'vac_billno', value: vac_billno },
  //         { name: 'SalesInvoiceSelection', value: JSON.stringify(CheckedInvoiceList) },
  //         { name: 'PaperType', value: this.state.formData.cmbPaper },
  //     ]
  //     console.log("reqData", reqData);
  //     var form = document.createElement("form");
  //     form.setAttribute("method", "post");
  //     form.setAttribute("action", apiURL + "salesdetail.php");
  //     form.setAttribute("target", "view");
  //     reqData.forEach((data) => {
  //         var hiddenField = document.createElement("input");
  //         hiddenField.setAttribute("type", "hidden");
  //         hiddenField.setAttribute("name", data.name);
  //         hiddenField.setAttribute("value", data.value);
  //         form.appendChild(hiddenField);
  //         document.body.appendChild(form);
  //     });

  //     window.open("", "view");

  //     form.submit();
  //     this.props.updateProcessing("success", "PDF Open in next Tab.");
  // };

  openInvoice = (
    bint_acid,
    bint_acyear,
    vac_billno = "",
    CheckedInvoiceList,
    array_billno = [],
    vac_frombillno = 0,
    vac_tobillno = 0,
    vac_customer = "",
    dat_fromdate = "",
    dat_todate = ""
  ) => {
    this.props.notifyProcessing();
    let reqData = [
      { name: "Op", value: "SalesInvoicePrint" },
      { name: "bint_acid", value: bint_acid },
      { name: "bint_acyear", value: bint_acyear },
      { name: "vac_billno", value: vac_billno },
      { name: "array_billno", value: JSON.stringify(array_billno) },
      { name: "vac_frombillno", value: vac_frombillno },
      { name: "vac_tobillno", value: vac_tobillno },
      { name: "vac_customer", value: vac_customer },
      { name: "dat_fromdate", value: dat_fromdate },
      { name: "dat_todate", value: dat_todate },
      {
        name: "SalesInvoiceSelection",
        value: JSON.stringify(CheckedInvoiceList),
      },
      { name: "PaperType", value: this.state.formData.cmbPaper },
      {
        name: "bolPrintSingatureStamp",
        value: this.state.formData.chkPrintSignatureAndStamp ? 1 : 0,
      },
    ];
    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiURL + "salesdetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "SalesList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };
  //#endregion

  render() {
    console.log(
      "this.state.formData.chkPrintSignatureAndStamp",
      this.props.IntSignature_StampPrint
    );
    console.log("vac_billno", this.props.vac_billno);

    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          marginTop={0}
          marginBottom={0}
        >
          <Grid item>
            <CtCmb
              id="cmbPaper"
              label="Paper"
              items={this.state.PaperList}
              value={this.state.formData.cmbPaper}
              handleOnChange={this.handleOnChange}
              width={150}
              maxLength={50}
              colID="name"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          marginTop={0}
          marginBottom={0}
        >
          <Grid item>
            <CtBtn label="Select All" onClick={this.SelectAll} />
          </Grid>
          <Grid item>
            <CtBtn label="Clear All" onClick={this.ClearAll} />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          marginTop={0}
          marginBottom={0}
        >
          <Grid item>
            <CtCheckBox
              id="chkPrintSignatureAndStamp"
              name="chkPrintSignatureAndStamp"
              label="Print Signature and Stamp"
              checked={this.state.formData.chkPrintSignatureAndStamp}
              handleCheckChange={this.handleOnChkChange}
              // disabled={this.state.diableChk}
              // onKeyDown={this.props.onKeyDown}
              // nextCtrlID="cmbInvoiceFormat"
            ></CtCheckBox>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={0}
          marginBottom={0}
        >
          <Grid item>
            <TableList
              columns={this.state.columns}
              counter={this.state.counter}
              rows={this.state.rows}
              rowsCount={this.state.rowsCount}
              rowsPerPage={this.state.rowsPerPage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              // handleOnActionClick={this.handleARDonActionClick}
              // actionList={this.state.actionList}
              // keyColumn={this.state.keyColumn}
              // handleOnSearchChange={this.handleOnSearchChange}
              // searchColumns={this.state.searchColumns}
              // searchData={this.state.searchData}
              // handleOnNewEntryClick={this.handleOnNewEntryClick}
              handleOnRowDataChange={this.handleOnRowDataChange}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={0}
          marginBottom={0}
        >
          <Grid item>
            <CtBtn label="Print Invoice" onClick={this.openInvoicePrint} />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </div>
    );
  }
}

export default withRouter(
  connect(
    mapStatetoProps,
    mapSetActiveMenuToProps
  )(HoCtToastContainer(SalesInvoiceSelection))
);
